export const CORE_GTM_TRACKING_VALUES = {
  name: {
    componentEvent: 'componentevent',
    workflowEvent: 'workflowevent',
    ctaEvent: 'ctaevent',
    socialEvent: 'socialevent'
  },
  componentGroup: {
    campaigns: 'campaigns',
    newCars: 'new-cars'
  },
  componentName: {
    button: 'button-component',
    carousel: 'carousel',
    featureCard: 'feature-card',
    videoPlayer: 'video-player',
    overlay: 'overlay',
    gallery: 'gallery',
    galleryImage: 'gallery-image',
    socialMediaSharebutton: 'social-media-share-button',
    loginBanner: 'login-banner',
    videoBanner: 'video-banner'
  },
  action: {
    homeScreen: 'home-screen',
    clickCta: 'click-cta',
    clickLink: 'click-link',
    clickButton: 'click-button',
    clickTab: 'click-tab',
    viewPicture: 'view-picture',
    playVideo: 'play-video',
    browseVersion: 'browse-version',
    deleteVersion: 'delete-version',
    confirmDelete: 'confirm-delete',
    browseStory: 'browse-story',
    workflowStep: 'workflow-step',
    browseContent: 'browse-content',
    openOverlay: 'open-overlay',
    closeOverlay: 'close-overlay',
    share: 'share',
    addFilter: 'add-filter',
    addImage: 'add-image',
    nextStep: 'next-step',
    previousStep: 'previous-step'
  },
  label: {
    general: 'general',
    view: 'view',
    personalise: 'personalise',
    startExperience: 'start-experience',
    seeMore: 'see-more',
    onlineCarReservation: 'online-car-reservation',
    prepareResult: 'prepare-result',
    exploreExperience: 'explore-experience',
    resultScreen: 'result-screen',
    resultsScreen: 'results-screen',
    startScreen: 'start-screen',
    loginScreen: 'login-screen',
    close: 'close',
    loadMore:'load-more',
    hideFilters: 'hide-filters',
    showFilters: 'show-filters',
    loginInstagram: 'login-instagram',
    continueWithoutLogin: 'continue-without-login',
    imageSelectionScreen: 'images-selection-screen',
    paletteGenerationLoadingScreen: 'palette-generation-loading-screen',
    paletteScreen: 'palette-screen',
    confirmPalette: 'confirm-palette',
    refreshColours: 'refresh-colours',
    artworkSelectionScreen: 'artwork-selection-screen',
    confirmArtworkSelection: 'confirm-artwork-selection',
    carColourScreen: 'car-colour-screen',
    createArtwork: 'create-artwork',
    artworkGenerationLoadingScreen: 'artwork-generation-loading-screen',
    artworkScreen: 'artwork-screen',
    downloadArtwork: 'download-artwork',
    addToCollection: 'add-to-collection',
    createNewArtwork: 'create-new-artwork',
    login: 'mylexus-login',
    register: 'mylexus-register',
    blank: ''
  }
};